// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-threat-triggered-access-review.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-threat-triggered-access-review',
  title:
    'Review and update access control schemes in response to new threats and security incidents',
  description:
    'Access control schemes for systems and data used in service delivery must be reviewed and updated not only on a periodic basis but also as a specific response to new threats, identified vulnerabilities, emerging capabilities and lessons learned from security incidents — in accordance with the most recent risk assessment.',
  category: 'access',
  scfIds: ['SCF-IAM-001', 'SCF-RSK-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Threat-triggered access review procedure is documented',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
